<script lang="tsx">
  import { type PropType } from "vue";
  import type { MenuTreeType } from "@/gql/graphql";

  import { FontAwesomeIcon as Icon } from "@fortawesome/vue-fontawesome";
  import { faAngleRight, faAngleLeft, faXmark } from "@fortawesome/free-solid-svg-icons";
  import { Button, Menu } from "primevue";
  import type { MenuItem } from "primevue/menuitem";

  export default {
    components: { Button, Icon, Menu },
    props: {
      tree: {
        type: Object as PropType<MenuTreeType>,
        required: true,
      },
      button: {
        value: String as PropType<"back" | "close">,
        required: true,
      }
    },
    data() { return {
      faAngleRight, faAngleLeft, faXmark,
      menuDt: {
        border: { color: 'transparent' }
      }
    }},
    computed: {
      menuItems() {
        const items: MenuItem[] = [
          {
            label: this.tree.label!,
            command: this.back,
            class: "header",
            ariaLabel: this.button,
            icon: this.button === 'back' ? "faAngleLeft" : "faXmark",
            isHeader: true,
          },
        ];
        for (const [i, child] of (this.tree.children ?? []).entries()) {
          const hasChildren = child!.children !== undefined && (child?.children?.length ?? 0) > 0;
          items.push({
            label: child!.label!,
            url: child!.href ?? undefined,
            class: hasChildren ? ["item", "children"] : ["item"],
            icon: hasChildren ? "faAngleRight" : undefined,
            command: hasChildren ? () => { this.select(i); } : undefined,
            hasChildren,
            isHeader: false,
          });
        }
        return items;
      }
    },
    emits: {
      select(i: number) { return true; },
      back() { return true; },
    },
    methods: {
      select(i: number) {
        this.$emit("select", i);
      },
      back() {
        this.$emit("back");
      }
    },
  };
</script>

<template>
  <div class="menupane">
    <Menu :model="menuItems" :dt="menuDt">
      <template #item="{item, props}">
        <a v-bind="props.action" :href="!item.hasChildren ? item.url : undefined">
          <Icon v-if="item.icon !== undefined && item.isHeader"
            :icon="this![item.icon]!"/>
          <span>{{ item.label }}</span>
          <Icon v-if="item.icon !== undefined && !item.isHeader"
            :icon="this![item.icon]!"/>
        </a>
      </template>
    </Menu>
  </div>
</template>

<style lang="less" scoped>

.menupane {
  height: fit-content;
  width: 100%;

  & :deep(.p-menu-item-content .p-menu-item-link) {
    display: inline-flex;
    width: 100%;
    word-break: break-word;
  }

  & :deep(.p-menu-item.header) {
    font-family: var(--font-header);
    font-weight: 600;
  }

  & :deep(.p-menu-item.item .p-menu-item-content .p-menu-item-link) {
    justify-content: space-between;
  }
}

</style>
